import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Popup from "reactjs-popup";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import "./DomainSearch.css";
import { FaCrown, FaLock, FaRegQuestionCircle } from "react-icons/fa";
import toast from "react-hot-toast";

ProductCard.propTypes = {
  product: PropTypes.object.isRequired,
};

function ProductCard({ product }) {
  return (
    <div className="p-[2px]">
      <Card
        sx={{
          width: "100%",
          borderRadius: "16px",
          border: "1px solid #f1f1f1",
          boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
        }}
        className="marketplace-card-main"
      >
        <CardContent sx={{ paddingBottom: "12px", paddingTop: "12px" }}>
          {/* Domain Name */}
          <Typography
            component="div"
            sx={{
              fontWeight: "800",
              color: "#1b4965",
              textTransform: "lowercase",
            }}
            className="!text-[35px] text-pent !text-left mt-[-14px]"
          >
            {product.name}
          </Typography>

          {/* Description */}
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontSize: "16px" }}
            className="cardlist-text line-clamp-3 mt-[6px]"
          >
            {product.description ||
              "A premium .gold domain available for acquisition."}
          </Typography>

          {/* Premium Badge */}
          {product.premium && (
            <div className="flex items-center gap-1 mt-[10px]">
              <FaCrown className="text-[#b99653]" />
              <span className="text-[#b99653] font-semibold text-sm uppercase">
                Premium Domain
              </span>
            </div>
          )}
        </CardContent>

        {/* Price & Category Info */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            padding: "0px 16px 8px",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: "600",
              fontSize: "22px",
              color: "#101c4c",
            }}
          >
            ₹{" "}
            {product.price
              ? product.price.toLocaleString()
              : "Contact for Price"}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontSize: "15px",
              color: "#777",
              textTransform: "capitalize",
            }}
          >
            {product.category || "Domain"}
          </Typography>
        </Box>

        {/* CTA Buttons - all in one line */}
        <div className="flex justify-between items-center flex-wrap gap-2 px-[16px] pb-[16px]">
          {/* Know More */}
          <Link to={`/Marketplace_Product/${product._id}`} className="flex-1">
            <button className="white-btn Premiumproducts_btn  !py-[8px] !px-[12px] w-full">
              Know More
            </button>
          </Link>

          <CardActions className="flex-1 !p-0">
            <Popup
              trigger={
                <button className="white-btn Premiumproducts_btn !border-[#b99653] !py-[8px] !px-[12px] w-full">
                  Buy Now
                </button>
              }
              modal
              nested
              contentStyle={{
                background: "transparent",
                border: "none",
                boxShadow: "none",
                padding: 0,
              }}
            >
              {(close) => (
                <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm z-50 animate-fadeIn">
                  <div className="relative bg-white rounded-2xl shadow-2xl border border-[#b99653]/20 w-[90%] max-w-md p-8 text-center transform transition-all scale-100 hover:scale-[1.02] duration-300">
                    {/* Close Button */}
                    <button
                      onClick={close}
                      className="absolute top-3 right-4 text-3xl font-semibold text-gray-400 hover:text-[#b99653] transition"
                    >
                      ×
                    </button>

                    <FaLock className="m-auto text-[#b99653] mb-4" size={42} />
                    <h2 className="text-[26px] font-bold text-[#101c4c] mb-2">
                      Secure Purchase
                    </h2>
                    <p className="text-gray-600 text-[15px] mb-4">
                      Complete your transaction safely through our secure
                      payment system. Your ownership transfer is 100% verified
                      and protected.
                    </p>

                    <Link to={`/Marketplace-checkout/${product._id}`}>
                      <button
                        onClick={close}
                        className="px-6 py-2.5 rounded-lg text-white font-semibold shadow-md transition-all hover:shadow-lg"
                        style={{
                          background:
                            "linear-gradient(to right, #bc833bdb, #fcdb6a, #e3b757)",
                        }}
                      >
                        Proceed to Checkout
                      </button>
                    </Link>
                  </div>
                </div>
              )}
            </Popup>
          </CardActions>

          {/* Enquire Popup */}
          <CardActions className="flex-1 !p-0">
            <Popup
              trigger={
                <button className="white-btn Premiumproducts_btn !border-[#777] !py-[8px] !px-[12px] w-full flex items-center justify-center gap-1">
                  <FaRegQuestionCircle />
                  Enquire
                </button>
              }
              modal
              nested
              contentStyle={{
                background: "transparent",
                border: "none",
                boxShadow: "none",
                padding: 0,
              }}
            >
              {(close) => (
                <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm z-50 animate-fadeIn">
                  <div className="relative bg-white rounded-2xl shadow-2xl border border-[#b99653]/20 w-[90%] max-w-md p-8 text-center transform transition-all scale-100 hover:scale-[1.02] duration-300">
                    {/* Close Button */}
                    <button
                      onClick={close}
                      className="absolute top-3 right-4 text-3xl font-semibold text-gray-400 hover:text-[#b99653] transition"
                    >
                      ×
                    </button>

                    <h2 className="text-[26px] font-bold text-[#101c4c] mb-2">
                      Send an Enquiry
                    </h2>
                    <p className="text-gray-600 text-[15px] mb-4">
                      Interested in this domain? Drop your message below, and
                      our team will reach out shortly.
                    </p>

                    <form
                      onSubmit={(e) => {
                        e.preventDefault();
                        toast.success("Your enquiry has been submitted!");
                        close();
                      }}
                      className="mt-2"
                    >
                      <textarea
                        placeholder="Enter your message..."
                        className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#b99653] text-gray-700 text-sm resize-none"
                        rows="3"
                      />
                      <button
                        type="submit"
                        className="px-6 py-2.5 rounded-lg text-white font-semibold shadow-md mt-4 transition-all hover:shadow-lg"
                        style={{
                          background:
                            "linear-gradient(to right, #bc833bdb, #fcdb6a, #e3b757)",
                        }}
                      >
                        Submit Enquiry
                      </button>
                    </form>
                  </div>
                </div>
              )}
            </Popup>
          </CardActions>
        </div>
      </Card>
    </div>
  );
}

export default ProductCard;
